<div class="flex flex-col w-full max-h-[90vh] relative">

    <!-- Header -->
    <div class="flex items-center p-6 w-full relative flex-shrink-0">
        <div class="p-2 rounded-xl bg-blue-100 ml-2 w-[44px] h-[44px] flex items-center justify-center">
            <mat-icon svgIcon="mat_solid:storage" class="icon-size-6 text-blue-600"></mat-icon>
        </div>
        <div class="px-3">
            <div class="w-full leading-10">
                <span class="text-[24px] font-[600] font-remote">Armazenamento</span>
            </div>
        </div>
        <div (click)="close()" class="mx-4 rounded-full hover:bg-gray-100 cursor-pointer absolute right-0 p-2 w-[44px] h-[44px] top-[20px]">
            <mat-icon class="text-gray-700 hover:text-gray-500 icon-size-7 right-0 relative" svgIcon="mat_solid:close"></mat-icon>
        </div>
    </div>

    <!-- Body (scrollável) -->
    <div class="w-full overflow-y-auto flex-1 min-h-0 px-4">

        <!-- Aviso: snapshot ainda não computado pela fila -->
        <div *ngIf="storageComputing" class="w-full pt-3">
            <span class="font-inter font-[400] text-[12px] text-gray-400">Dados de armazenamento estão sendo atualizados...</span>
        </div>

        <!-- Seção: Visão geral -->
        <div class="w-full py-6">
            <div class="flex w-full">
                <div class="p-2 rounded-xl bg-blue-100 ml-2 h-[40px]">
                    <mat-icon svgIcon="mat_solid:storage" class="icon-size-6 text-blue-600"></mat-icon>
                </div>
                <div class="px-3">
                    <div class="w-full leading-10">
                        <span class="text-[17px] font-[500] font-remote">Visão geral</span>
                    </div>
                </div>
            </div>
            <div class="w-full p-4">
                <div class="w-full rounded-xl bg-gray-50 border border-gray-100 p-4">
                    <div class="flex items-center justify-between mb-2">
                        <span class="font-inter font-[400] text-[12px] text-gray-500">Armazenamento utilizado</span>
                        <span class="font-inter font-[600] text-[12px] text-gray-700">{{ usedPercent }}%</span>
                    </div>
                    <div class="w-full h-2 bg-gray-200 rounded-full overflow-hidden">
                        <div class="h-full bg-[#0061ff] rounded-full transition-all duration-500"
                             [style.width.%]="usedPercent"></div>
                    </div>
                    <div class="mt-2">
                        <span class="font-inter font-[400] text-[12px] text-gray-600">
                            {{ formatBytes(storage?.used_bytes) }} usado de {{ formatBytes(storage?.total_bytes) }} ({{ usedPercent }}%)
                        </span>
                    </div>
                </div>
            </div>
        </div>

        <!-- Seção: Distribuição por origem -->
        <div class="w-full py-6">
            <div class="flex w-full">
                <div class="p-2 rounded-xl bg-blue-100 ml-2 h-[40px]">
                    <mat-icon svgIcon="mat_solid:pie_chart" class="icon-size-6 text-blue-600"></mat-icon>
                </div>
                <div class="px-3">
                    <div class="w-full leading-10">
                        <span class="text-[17px] font-[500] font-remote">Distribuição por origem</span>
                    </div>
                </div>
            </div>
            <div class="w-full p-4">
                <!-- Arquivos (bucket) -->
                <div class="w-full flex py-3 border-b border-b-gray-100">
                    <div class="w-10 h-10 rounded-xl bg-amber-100 flex items-center justify-center flex-shrink-0">
                        <mat-icon svgIcon="mat_solid:folder_open" class="icon-size-5 text-amber-600"></mat-icon>
                    </div>
                    <div class="px-3 flex-1">
                        <div class="flex items-center justify-between">
                            <span class="font-inter text-gray-900 text-[14px] font-[500]">Arquivos (bucket)</span>
                            <span class="font-remote font-[600] text-[14px] text-gray-700">{{ formatBytes(storage?.bucket_bytes) }}</span>
                        </div>
                        <div class="w-full h-1.5 bg-gray-200 rounded-full overflow-hidden mt-2">
                            <div class="h-full bg-amber-400 rounded-full transition-all duration-500"
                                 [style.width.%]="percentOfTotal(storage?.bucket_bytes)"></div>
                        </div>
                    </div>
                </div>

                <!-- Banco de dados -->
                <div class="w-full flex py-3 border-b border-b-gray-100">
                    <div class="w-10 h-10 rounded-xl bg-emerald-100 flex items-center justify-center flex-shrink-0">
                        <mat-icon svgIcon="mat_solid:dns" class="icon-size-5 text-emerald-600"></mat-icon>
                    </div>
                    <div class="px-3 flex-1">
                        <div class="flex items-center justify-between">
                            <span class="font-inter text-gray-900 text-[14px] font-[500]">Banco de dados</span>
                            <span class="font-remote font-[600] text-[14px] text-gray-700">{{ formatBytes(storage?.db_bytes) }}</span>
                        </div>
                        <div class="w-full h-1.5 bg-gray-200 rounded-full overflow-hidden mt-2">
                            <div class="h-full bg-emerald-400 rounded-full transition-all duration-500"
                                 [style.width.%]="percentOfTotal(storage?.db_bytes)"></div>
                        </div>
                    </div>
                </div>

                <!-- Cota do plano -->
                <div class="w-full flex py-3">
                    <div class="w-10 h-10 rounded-xl bg-blue-100 flex items-center justify-center flex-shrink-0">
                        <mat-icon svgIcon="mat_solid:cloud" class="icon-size-5 text-blue-600"></mat-icon>
                    </div>
                    <div class="px-3 flex-1">
                        <div class="flex items-center justify-between">
                            <span class="font-inter text-gray-900 text-[14px] font-[500]">Cota do plano</span>
                            <span class="inline-flex items-center bg-blue-100 text-blue-700 font-bold text-xs px-2.5 py-0.5 rounded-full tracking-wide uppercase">
                                {{ storage?.plan_storage_gb || 0 }} GB
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Seção: Contadores -->
        <div class="w-full py-6">
            <div class="flex w-full">
                <div class="p-2 rounded-xl bg-blue-100 ml-2 h-[40px]">
                    <mat-icon svgIcon="mat_solid:table_chart" class="icon-size-6 text-blue-600"></mat-icon>
                </div>
                <div class="px-3">
                    <div class="w-full leading-10">
                        <span class="text-[17px] font-[500] font-remote">Contadores</span>
                    </div>
                </div>
            </div>
            <div class="w-full p-4">
                <div class="grid grid-cols-2 it:grid-cols-3 gap-3">
                    <div class="bg-gray-100 rounded-xl p-4 text-center">
                        <mat-icon svgIcon="mat_solid:description" class="icon-size-6 text-blue-600 mb-1"></mat-icon>
                        <span class="font-remote font-[700] text-[18px] text-gray-800 block">{{ counter('documents_processed') }}</span>
                        <span class="font-inter font-[400] text-[11px] text-gray-500 uppercase block">Comprovantes processados</span>
                    </div>
                    <div class="bg-gray-100 rounded-xl p-4 text-center">
                        <mat-icon svgIcon="mat_solid:graphic_eq" class="icon-size-6 text-blue-600 mb-1"></mat-icon>
                        <span class="font-remote font-[700] text-[18px] text-gray-800 block">{{ counter('meetings_transcribed') }}</span>
                        <span class="font-inter font-[400] text-[11px] text-gray-500 uppercase block">Reuniões transcritas</span>
                    </div>
                    <div class="bg-gray-100 rounded-xl p-4 text-center">
                        <mat-icon svgIcon="mat_solid:group" class="icon-size-6 text-blue-600 mb-1"></mat-icon>
                        <span class="font-remote font-[700] text-[18px] text-gray-800 block">{{ counter('members_count') }}</span>
                        <span class="font-inter font-[400] text-[11px] text-gray-500 uppercase block">Membros</span>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- Footer -->
    <div class="flex items-center justify-end gap-2 p-6 pt-4 flex-shrink-0">
        <button (click)="close()"
                class="flex items-center gap-2 px-5 py-2 rounded-3xl bg-[#0061ff] hover:bg-[#2f75e7] transition-colors cursor-pointer">
            <mat-icon class="icon-size-5 text-white" svgIcon="mat_solid:check"></mat-icon>
            <span class="font-remote font-[500] text-[14px] text-white">Fechar</span>
        </button>
    </div>
</div>